import VueI18n from 'vue-i18n';

export function translationsFromAttribute(element: Element, attributeName: string): VueI18n {
    return new VueI18n({
        locale: 'default',
        messages: {
            default: JSON.parse(element.getAttribute(attributeName) || '{}'),
        },
    });
}
